export const cargo = [
  {
    label: "Id",
    name: "idcargo",
    type: "INTEGER",
    readonly: true,
    showOnList: true,
  },
  {
    label: "Nombre",
    name: "nombre",
    type: "STRING",
    showOnList: true,
    showAsLabel: true,
  },
  {
    label: "Descripción",
    name: "descripcion",
    type: "STRING",
    showOnList: true,
  },
  {
    label: "Jerarquía",
    name: "jerarquia",
    type: "INTEGER",
    showOnList: true,
    allowNull: true,
  },
];
